import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AcceptHeaderInterceptor implements HttpInterceptor {
  public constructor() {}

  public intercept(
    request: HttpRequest<unknown>,
    httpHandler: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return httpHandler.handle(
      request.clone({
        headers: request.headers.set('Accept', [
          'application/json',
          'application/problem+json',
        ]),
      })
    );
  }
}
